import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import styled from 'styled-components'
import { injectGlobal } from 'styled-components'

injectGlobal`
  * { box-sizing: border-box; }
  body { margin: 0; }
`

import icon16 from '../images/favicon-16x16.png'
import icon32 from '../images/favicon-32x32.png'

const Layout = ({ children, data }) => (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        { name: 'description', content: 'Development of web and mobile apps. Team augmentation. Agile software engineering. High quality results that adapt to your needs.' },
        { name: 'keywords', content: 'same origin, same-origin, software engineering, web development, software house, develop mobile application, e-commerce, mvp, minimum viable product, rapid prototype, team augmentation, it outsourcing, quality code, modern development practises, singapore, south east asia, brian toh, jack veiga, made in alpha' },
      ]}
      link={[
          { rel: 'shortcut icon', type: 'image/png', href: `${icon16}` },
          { rel: 'shortcut icon', type: 'image/png', href: `${icon32}` },
      ]}
    />
    <div>
      {children()}
    </div>
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js